import { useQuery } from '@apollo/client';

export function mergeResults([d1, d2]: any[]) {
  return {
    ...d2,
    loading: d1.loading || d2.loading,
    error: d1.error ?? d2.error,
    data: d1.data &&
      d2.data && {
        page: {
          ...d2.data.page,
          body: (d2.data?.page?.body ?? []).map((slice: any, index: number) => {
            if (!slice.type && d1.data.page.body[index]?.type) {
              return d1.data.page.body[index];
            }
            return slice;
          }),
        },
      },
  };
}

export function useMergedQueries([firstQuery, secondQuery]: any, options: any) {
  const d1 = useQuery(firstQuery, options);
  const d2 = useQuery(secondQuery, options);
  return mergeResults([d1, d2]);
}
